import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs, siteInfo, trendingList } from "@/mocks/news";
import Hero from "./components/Hero";
import FeedSection from "./components/FeedSection";
import TimelineSection from "./components/TimelineSection";
import FiguresSection from "./components/FiguresSection";
import CategorySection from "./components/CategorySection";
import FaqSection from "./components/FaqSection";
import VoiceSection from "./components/VoiceSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  const location = useLocation();

  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: "https://sl858.cn/",
        description: siteInfo.description,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://sl858.cn/category/all?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: "https://sl858.cn/",
        email: siteInfo.email,
        description: siteInfo.description,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "今日热榜",
        itemListElement: trendingList.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `https://sl858.cn/article/${item.articleId}`,
        })),
      },
    ],
    [],
  );

  usePageMeta({
    title: "料闻社 - 独家黑料速递｜今日新料实时更新与事件时间线梳理",
    description:
      "料闻社专注独家黑料速递，今日新料实时更新，覆盖最新事件与人物动态。追踪独家黑料快报，获取不被删的完整时间线梳理，吃瓜看真相一步到位。",
    keywords: "独家黑料,独家黑料最新,独家黑料今日,独家黑料速递,独家黑料快报,事件时间线梳理",
    path: "/",
    jsonLd,
  });

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 80);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <FeedSection />
        <TimelineSection />
        <FiguresSection />
        <CategorySection />
        <FaqSection />
        <VoiceSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}